import axios from "axios";

// 상생 바로가기
export const specialShortcuts = [
  { icon: "sungsimdang", label: "빵장고", url: "/mypage/kiosk" },
  { icon: "mutualBenefit", label: "상생매장", url: "/mypage/store" },
  {
    icon: "bbdabang",
    label: "빵다방",
    url: "/mypage/bbdabang",
  },
  {
    icon: "admin",
    label: "상점관리",
    url: "http://admin.1472.ai:3002/auth/login",
  },
];

// 모노티 서비스 바로가기
export const monotiService = [
  { icon: "project", url: "/mypage/projectList", label: "프로젝트" },
  { icon: "scheduler", url: "/mypage/scheduler", label: "캘린더" },
  { icon: "group", url: "/group", label: "모임" },
];

// 상생 바로가기 보여주기 여부
export const checkKioskCond = (cmpnys, gbnCond = null) => {
  if (!cmpnys || !Array.isArray(cmpnys)) return false;

  const kioskCompanies = gbnCond
    ? [10001, 16421, 35719]
    : [4, 10001, 16421, 16786, 17333, 35719, 54899];

  return cmpnys.some(
    (cmpny) => kioskCompanies.includes(cmpny.cmpnyNo) || (gbnCond && cmpny.gbn === gbnCond),
  );
};

// 바로가기 버튼 기본값
export const checkDefaultQuick = (data, companies = []) => {
  if (!Array.isArray(companies) || companies.length === 0) return data;

  const kioskSet = new Set(["admin"]);

  companies.forEach((cmpny) => {
    if (cmpny.gbn === "ss") kioskSet.add("mutualBenefit");
    if ([10001, 16421, 16786, /* 으능 성심 상생센터*/ 35719].includes(cmpny.cmpnyNo))
      kioskSet.add("sungsimdang");
    if ([10001, 16421, 35719, 54899 /* 빵다방 */].includes(cmpny.cmpnyNo)) kioskSet.add("bbdabang");
  });

  const filterKiosk = specialShortcuts.filter((sc) => kioskSet.has(sc.icon));
  const defaultShortcut = [...filterKiosk, ...monotiService];

  const merged = [
    ...defaultShortcut.filter(
      (item) =>
        !data.some((d) => d.icon === item.icon && d.url === item.url && d.label === item.label),
    ),
    ...data,
  ];

  return merged.filter((item) => {
    if (item.url === "/mypage/mutualBenefit") return false;
    if (item.label === "빵보관소") return false;
    if (["mutualBenefit", "sungsimdang", "admin"].includes(item.icon)) {
      return kioskSet.has(item.icon);
    }
    return true;
  });
};

// const ADMIN_URL = "http://localhost:3002/auth/login";
const ADMIN_URL = "http://admin.1472.ai:3002/auth/login";

export const encryptMemberNo = async (mberNo) => {
  try {
    const { data } = await axios.post("/etc/encrypt", { scheduleNo: mberNo });
    return data?.encrypted;
  } catch (error) {
    console.error("멤버번호 암호화 실패:", error);
    return null;
  }
};

const buildAdminUrl = async (baseUrl, user) => {
  if (!user?.mberNo) return baseUrl;

  try {
    const encrypted = await encryptMemberNo(user.mberNo);
    return encrypted ? `${baseUrl}?mberNo=${encrypted}` : baseUrl;
  } catch (error) {
    console.error("관리자 URL 생성 실패:", error);
    return baseUrl;
  }
};

export const openAdmin = async (user, meassage = null) => {
  try {
    const url = await buildAdminUrl(ADMIN_URL, user);
    const targetWindow = window.open(url, "_blank");

    if (!targetWindow) {
      alert("팝업 차단을 해제해주세요.");
      return false;
    }

    if (meassage) {
      const { type, payload } = meassage;

      const handleChildReady = (event) => {
        if (event.data && event.data.type === "ADMIN_PAGE_READY") {
          const messageData = {
            type: type,
            payload: payload,
          };
          targetWindow.postMessage(messageData, "*");

          window.removeEventListener("message", handleChildReady);
        }
      };

      window.addEventListener("message", handleChildReady);

      setTimeout(() => {
        window.removeEventListener("message", handleChildReady);
        const messageData = {
          type: type,
          payload: payload,
        };
        targetWindow.postMessage(messageData, "*");
      }, 3000);
    }

    return true;
  } catch (error) {
    console.error("관리자 페이지 열기 실패:", error);
    alert("관리자 페이지를 열 수 없습니다.");
    return false;
  }
};
